module.exports = "https://cdn.thelire.com/ins/resource/delete.144f8d7296d12af21513c5cb138d9e00.png";